type UserWithRoles =
  | {
      roles?: Record<string, string[]>;
      defaultAccountId?: string;
    }
  | null
  | undefined;

export const hasPermission = (clientId: string | undefined, currentUser: UserWithRoles, permissions: string | string[]): boolean => {
  const userRoles = clientId ? currentUser?.roles?.[clientId] || [] : currentUser?.roles?.[currentUser?.defaultAccountId || ''] || [];

  if (permissions) {
    if (!Array.isArray(permissions)) {
      permissions = [permissions];
    }

    return permissions.some((role) => userRoles.indexOf(role) >= 0);
  }
  return false;
};
